import axios, { AxiosInstance } from 'axios'


export const authHttpClient = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API_BASE_URL!,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

const addAppInfoRequestInterceptor = (httpClient: AxiosInstance) => {
  httpClient.interceptors.request.use(
    (requestConfig) => {
      if (!requestConfig.headers) {
        requestConfig.headers = {}
      }
      requestConfig.headers['X-App-Info'] = 'ZocksConsole'
      return requestConfig
    },
    (error) => {
      console.error(error)
    },
  )
}

const addDataExtractInterceptor = (httpClient: AxiosInstance) => {
  httpClient.interceptors.response.use(
    (response) => response.data,
    (error) => {
      return Promise.reject({
        errorCode: error.code,
        statusCode: error.response.status,
        ...error.response.data,
      })
    },
  )
}


addDataExtractInterceptor(authHttpClient)
addAppInfoRequestInterceptor(authHttpClient)
